import { useMemo } from 'react';

import { getMSProductContentByEntitlement } from 'src/constants/ms-products.constants';
import { useSelectedClassAssets } from 'src/hooks/use-selected-class-assets.hook';
import { useSelfSignupUserCheck } from 'src/hooks/use-self-signup-user-check.hook';
import { useUserAssets } from 'src/hooks/use-user-assets.hook';
import {
  MSProduct,
  MSProductEntitlement,
} from 'src/interfaces/ms-product.types';
import AuthService from 'src/services/api/auth.service';
import {
  checkHasCoreProductsEntitlements,
  getHardcodedProductEntitlement,
} from 'src/services/entitlement.service';

// @TODO make internal
export const filterHardcodedProductContentByEntitlement = (
  entitlement: MSProductEntitlement,
) => {
  const filteredContent: MSProduct[] = [];
  const getContent = getMSProductContentByEntitlement;

  Object.entries(entitlement).forEach(([key, value]) => {
    if (value) {
      filteredContent.push(getContent()[key as keyof MSProductEntitlement]);
    }
  });

  return filteredContent;
};

export const useGetProductsByEntitlement = () => {
  const { data: userAssets } = useUserAssets();
  const selectedClassAssets = useSelectedClassAssets();
  const isSelfSignupUser = useSelfSignupUserCheck();
  const relevantAssets = AuthService.isTeacher()
    ? selectedClassAssets
    : userAssets;

  return useMemo(() => {
    const hardcodedProductEntitlement = getHardcodedProductEntitlement(
      relevantAssets,
      isSelfSignupUser ?? false,
    );

    return {
      productsByEntitlement: filterHardcodedProductContentByEntitlement(
        hardcodedProductEntitlement,
      ),
      hasCoreProductsEntitlements: checkHasCoreProductsEntitlements(
        hardcodedProductEntitlement,
      ),
    };
  }, [relevantAssets, isSelfSignupUser]);
};
